import React, { useState, useRef } from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import Globe from './components/Globe';
import StarField from './components/StarField';
import EnhancedMorphingText from './components/EnhancedMorphingText';
import { Github, Twitter, ImageIcon } from 'lucide-react';
import Modal from './components/Modal';
import { LocationMarker } from './components/LocationMarker';
import LoaderOne from "./components/loader-one";
import { FaTelegramPlane } from 'react-icons/fa';
import Gallery from './components/Gallery';

function HomePage() {
  const [modalState, setModalState] = useState({
    isOpen: false,
    simulacraId: null
  });
  const [copyStatus, setCopyStatus] = useState('');
  const globeRef = useRef();
  const selectedMarkerRef = useRef(null);

  const socialLinks = {
    github: 'https://somniumcra.gitbook.io/somniumcra',
    twitter: 'https://x.com/Somniumcra',
    telegram: 'https://t.me/somniumcra'
  };

  const handleSocialClick = (platform) => {
    window.open(socialLinks[platform], '_blank', 'noopener,noreferrer');
  };

  const handleSimulacraClick = (markerId) => {
    if (globeRef.current) {
      setModalState({ isOpen: false, simulacraId: null });
      globeRef.current.rotateToMarker(markerId);
      selectedMarkerRef.current = markerId;
    }
  };

  const handleGlobeMarkerClick = () => {
    if (selectedMarkerRef.current) {
      setModalState({
        isOpen: true,
        simulacraId: selectedMarkerRef.current
      });
    }
  };

  const locations = [
    { id: 'SIMULACRA_01', name: 'Ho Chi Minh City' },
    { id: 'SIMULACRA_02', name: 'New York' },
    { id: 'SIMULACRA_03', name: 'Istanbul' }
  ];

  const handleCopy = () => {
    navigator.clipboard.writeText('DhfZxM22E4nbCHPycSZmiqsnPN3WZhWPeqRCu7K1pump');
    setCopyStatus('Copied to clipboard!');
    setTimeout(() => setCopyStatus(''), 2000);
  };

  return (
    <div className="fixed inset-0 bg-black md:relative md:h-screen md:w-screen md:overflow-hidden">
      <StarField />
      
      <div className="absolute top-4 left-4 z-10 md:top-8 md:left-8">
        <h1 className="text-white font-inter text-xl md:text-2xl font-semibold tracking-wider mb-2 md:mb-3">
          SOMNIUMCRA
        </h1>
        <div className="text-white max-w-[300px] md:max-w-[400px]">
          <EnhancedMorphingText />
        </div>
      </div>

      <Link 
        to="/gallery" 
        className="absolute top-4 left-1/2 transform -translate-x-1/2 z-30 flex items-center gap-2 text-white opacity-80 hover:opacity-100 transition-opacity duration-300 md:top-8"
      >
        <ImageIcon className="w-5 h-5" />
        <span>Gallery</span>
      </Link>
      
      <div className="absolute right-4 top-4 z-30 flex flex-col gap-3 md:right-8 md:top-8 md:gap-4">
        {locations.map((location) => (
          <LocationMarker
            key={location.id}
            location={location}
            onClick={handleSimulacraClick}
          />
        ))}
      </div>

      
      <div className="absolute bottom-4 right-4 z-30 flex gap-3 md:bottom-8 md:right-8 md:gap-4">
        <button
            onClick={() => handleSocialClick('telegram')}
            className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-white bg-opacity-10 backdrop-blur-sm hover:bg-opacity-20 transition-all duration-300 ease-in-out group"
            aria-label="Visit Telegram Profile"
          >
            <FaTelegramPlane className="w-5 h-5 md:w-6 md:h-6 text-white opacity-80 group-hover:opacity-100 transition-opacity duration-300" />
          </button>
          <button
            onClick={() => handleSocialClick('github')}
            className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-white bg-opacity-10 backdrop-blur-sm hover:bg-opacity-20 transition-all duration-300 ease-in-out group"
            aria-label="Visit Gitbook"
          >
            <Github className="w-5 h-5 md:w-6 md:h-6 text-white opacity-80 group-hover:opacity-100 transition-opacity duration-300" />
          </button>

        <button
          onClick={() => handleSocialClick('twitter')}
          className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-white bg-opacity-10 backdrop-blur-sm hover:bg-opacity-20 transition-all duration-300 ease-in-out group"
          aria-label="Visit X (Twitter) Profile"
        >
          <Twitter className="w-5 h-5 md:w-6 md:h-6 text-white opacity-80 group-hover:opacity-100 transition-opacity duration-300" />
        </button>
      </div>

      <div className="absolute bottom-4 left-4 z-30 md:bottom-8 md:left-8">
        {copyStatus && (
          <div className="text-white text-xs md:text-sm font-mono opacity-70 ml-2">
            {copyStatus}
          </div>
        )}
      
        <span 
          className="text-white text-xs md:text-sm font-mono opacity-70 hover:opacity-100 transition-opacity duration-300"
          onClick={handleCopy}
          style={{ cursor: 'pointer' }}
        >
          CA: DhfZxM22E4nbCHPycSZmiqsnPN3WZhWPeqRCu7K1pump
        </span>
        
        
      </div>
      
      <div className="h-full w-full flex items-center justify-center">
        <div className="relative w-[90vw] h-[90vw] max-w-[600px] max-h-[600px] md:w-[600px] md:h-[600px] z-20">
          <div className="absolute inset-0">
            <Globe ref={globeRef} onMarkerClick={handleGlobeMarkerClick} />
          </div>
        </div>
      </div>

      {modalState.isOpen && modalState.simulacraId && (
        <Modal 
          isOpen={true}
          onClose={() => setModalState({ isOpen: false, simulacraId: null })}
          simulacraId={modalState.simulacraId}
        />
      )}
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/gallery" element={<Gallery />} />
    </Routes>
  );
}

export default App;